import { gql } from "@apollo/client";

export const AddProject = gql`
  mutation AddProject(
    $token: String!
    $customerID: ID!
    $ldgrID: ID!
    $user_details: SubscribedUser!
    $input: CreateAtsAcLdgrProjects!
  ) {
    AddProject(
      token: $token
      customerID: $customerID
      ldgrID: $ldgrID
      user_details: $user_details
      input: $input
    ) {
      id
    }
  }
`;

export const UpdateProject = gql`
  mutation UpdateProject(
    $token: String!
    $customerID: ID!
    $projectID: ID!
    $user_details: SubscribedUser!
    $input: UpdateAtsAcLdgrProjects!
  ) {
    UpdateProject(
      token: $token
      customerID: $customerID
      projectID: $projectID
      user_details: $user_details
      input: $input
    ) {
      id
    }
  }
`;

export const DeleteProject = gql`
  mutation DeleteProject(
    $token: String!
    $customerID: ID!
    $projectID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteProject(
      token: $token
      customerID: $customerID
      projectID: $projectID
      user_details: $user_details
    )
  }
`;

export const AddProjectHeader = gql`
  mutation AddProjectHeader(
    $token: String!
    $header: String!
    $initData: Boolean!
    $dataType: String!
    $projectID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    AddProjectHeader(
      token: $token
      header: $header
      initData: $initData
      projectID: $projectID
      customerID: $customerID
      user_details: $user_details
      dataType: $dataType
    )
  }
`;

export const UpdateProjectHeader = gql`
  mutation UpdateProjectHeader(
    $token: String!
    $header: String!
    $initData: Boolean!
    $dataType: String!
    $projectHeaderID: ID!
    $customerID: ID!
    $status: Boolean
    $user_details: SubscribedUser!
  ) {
    UpdateProjectHeader(
      token: $token
      header: $header
      initData: $initData
      projectHeaderID: $projectHeaderID
      customerID: $customerID
      user_details: $user_details
      status: $status
      dataType: $dataType
    )
  }
`;

export const DeleteProjectHeader = gql`
  mutation DeleteProjectHeader(
    $token: String!
    $projectHeaderID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteProjectHeader(
      token: $token
      projectHeaderID: $projectHeaderID
      customerID: $customerID
      user_details: $user_details
    )
  }
`;

export const ReOrderProjectHeader = gql`
  mutation ReOrderProjectHeader(
    $token: String!
    $customerID: ID!
    $input: [ReOrderHeaders!]!
    $user_details: SubscribedUser!
  ) {
    ReOrderProjectHeader(
      token: $token
      customerID: $customerID
      input: $input
      user_details: $user_details
    )
  }
`;

export const AddProjectPmuRemark = gql`
  mutation AddProjectPmuRemark(
    $token: String!
    $pmuRemarks: String!
    $reportDate: Time!
    $projectID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    AddProjectPmuRemark(
      token: $token
      pmuRemarks: $pmuRemarks
      reportDate: $reportDate
      projectID: $projectID
      customerID: $customerID
      user_details: $user_details
    )
  }
`;

export const AtsProjectInitData = gql`
  mutation AtsProjectInitData(
    $token: String!
    $input: [AtsProjectInitDataInput!]!
    $reportDate: Time!
    $projectID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    AtsProjectInitData(
      token: $token
      input: $input
      reportDate: $reportDate
      projectID: $projectID
      customerID: $customerID
      user_details: $user_details
    )
  }
`;

export const AddProjectDailyReports = gql`
  mutation AddProjectDailyReports(
    $token: String!
    $reportDate: Time!
    $input: [AtsProjectInitDataInput!]!
    $projectID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    AddProjectDailyReports(
      token: $token
      reportDate: $reportDate
      input: $input
      projectID: $projectID
      customerID: $customerID
      user_details: $user_details
    )
  }
`;

export const UpdateProjectDailyReports = gql`
  mutation UpdateProjectDailyReports(
    $token: String!
    $AtsProjectDailyReportsID: ID!
    $input: [AtsProjectInitDataInput!]!
    $projectID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    UpdateProjectDailyReports(
      token: $token
      AtsProjectDailyReportsID: $AtsProjectDailyReportsID
      input: $input
      projectID: $projectID
      customerID: $customerID
      user_details: $user_details
    )
  }
`;

export const AtsAddOrUpdateProjectInitData = gql`
  mutation AtsAddOrUpdateProjectInitData(
    $token: String!
    $reportDate: Time!
    $input: [AtsProjectInitDataInput!]!
    $projectID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    AtsAddOrUpdateProjectInitData(
      token: $token
      reportDate: $reportDate
      input: $input
      projectID: $projectID
      customerID: $customerID
      user_details: $user_details
    )
  }
`;

export const UpdateProjectPmuRemark = gql`
  mutation UpdateProjectPmuRemark(
    $token: String!
    $pmuRemarks: String!
    $AtsProjectDailyReportsID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    UpdateProjectPmuRemark(
      token: $token
      pmuRemarks: $pmuRemarks
      AtsProjectDailyReportsID: $AtsProjectDailyReportsID
      customerID: $customerID
      user_details: $user_details
    )
  }
`;
